/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-03-19 15:12:49 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-03-19 16:40:11
 */
import { bindMethods } from "helpers/bindMethods";

export class UserPermissionService {

    constructor(store) {
        this.store = store;

        bindMethods(this);
    }

    get state() {
        return this.store.getState();
    }

    isLoggedIn() {
        const { user } = this.state;

        return user && user.isLogged;
    }

    isAdmin() {
        const { user } = this.state;

        return user && user.isLogged && user.user.role === "admin";
    }

    isModerator() {
        const { user } = this.state;

        return user && user.isLogged && user.user.role === "moderator";
    }

}


// WEBPACK FOOTER //
// ./app/store/userPermissions.js